var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-control",attrs:{"type":"number","id":_vm.inputId,"name":_vm.inputName,"required":_vm.required,"step":"1","min":_vm.numberMin,"max":_vm.numberMax,"readonly":_vm.disabled},domProps:{"value":_vm.value}})}
var staticRenderFns = []

export { render, staticRenderFns }